import type { Conversation } from '@twilio/conversations';

import { credentialsPromise } from './credentials';
import { getClient } from './client';
import { logInfo } from '../logger';

async function isConversationReady(conversation: Conversation) {
  return new Promise((resolve) => {
    (function check() {
      if (conversation?.status === 'joined') {
        return resolve(true);
      }
      setTimeout(check, 1000);
    })();
  });
}

let conversationPromise: Promise<Conversation> | null = null;

export async function getTwilioConversation(): Promise<Conversation> {
  if (!conversationPromise) {
    conversationPromise = initializeConversation();
  }
  return conversationPromise;
}

async function initializeConversation() {
  try {
    const { conversation_sid } = await credentialsPromise;

    const client = await getClient();
    const conversation = await client.peekConversationBySid(conversation_sid);

    await isConversationReady(conversation);

    logInfo(`%c CDP: ${conversation.friendlyName} `, 'background: #222; color: #00b48d; line-height: 1.5');

    return conversation;
  } catch (error) {
    // Reset conversationPromise to allow retries in case of failure
    conversationPromise = null;
    throw error;
  }
}
